import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ICameraPreview } from '@shared/interfaces/camera-preview';
import { DevicePublisherService } from '@shared/services/publishers/device-publisher.service';
import { Subscription } from 'rxjs';
import { PERMISSIONS } from '@access/permissions';
import { AccessService } from '@access/access.service';

@Component({
  selector: 'app-camera-preview-modal',
  templateUrl: './camera-preview-modal.component.html',
  styleUrls: ['./camera-preview-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CameraPreviewModalComponent implements OnInit, OnDestroy {

  @Input() deviceId!: string;
  @Input() deviceName!: string;
  @Input() supportLiveStream = false;
  subscription = new Subscription();
  cameraPreviewData!: ICameraPreview;
  private timeInterval: any;
  currentDate = new Date();

  constructor(
    protected dialogRef: NbDialogRef<CameraPreviewModalComponent>,
    private changeDetectorRef: ChangeDetectorRef,
    private devicePublisherService: DevicePublisherService,
    private readonly accessService: AccessService) {
  }

  deviceDataToStream() {
    return { deviceId: this.deviceId, deviceName: this.deviceName };
  }

  ngOnInit(): void {
    if (this.supportLiveStream) {
      this.timeInterval = setInterval(() => {
        this.currentDate = new Date();
        this.changeDetectorRef.markForCheck();
      }, 1000);
    } else {
      this.getCameraPreview();
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  }

  onStreamTimeout(res: any) {
    if (res) {
      this.cancel();
    }
  }

  featureIsAvailable(): boolean {
    return this.accessService.hasPermission(PERMISSIONS.Camera.View);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  getCameraPreview(): void {
    this.subscription = this.devicePublisherService.getCameraPreviewObservable(this.deviceId).subscribe(res => {
      if (res) {
        this.cameraPreviewData = res;
        this.changeDetectorRef.markForCheck();
      }
    });
  }
}
